import React from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

import { APIAgentActivityLog, APIIntercom } from "../../../../api";
import DialogConfirm from "../DialogConfirm/DialogConfirm";
import CreateDiscount from "../CreateDiscount";
import DeleteCustomerAccount from "../DeleteCustomerAccount/DeleteCustomerAccount";

import { useCustomerProvider, useAdminProviderDataContext } from "../../../../context";
import { CompleteEvaluation } from "../index";

interface IProps {
  setPopup: (popup: string) => void;
}

const ManagementConfirmWindows: React.FC<IProps> = ({ setPopup }) => {
  const { customer } = useCustomerProvider();
  const {
    user: { allowed_features },
  } = useAdminProviderDataContext();
  const { activePlan } = useSelector((state) => state.customer.plans.data);
  const isActiveCurrentPlan = !activePlan || !!activePlan?.passed;
  return (
    <div>
      <b>Management:</b>
      <Box display="flex" flexDirection="row" justifyContent="space-between" padding="10px 0">
        <DialogConfirm
          mainButtonProps={{
            disabled: isActiveCurrentPlan,
          }}
          isShowMainButton
          dialogTitle="Reset User"
          contentText="Are you sure you want to reset user?"
          buttonText="Reset User"
          onClickConfirm={() => {
            APIAgentActivityLog.resetAccountLogRequest({ accounts_id: customer.id });
            window.open(`https://api.earn2trade.com/mgmt/clear_reset/${customer.xid}`);
          }}
        />
        <DialogConfirm
          mainButtonProps={{
            disabled: isActiveCurrentPlan,
          }}
          isShowMainButton
          dialogTitle="Clear Failure"
          contentText="Are you sure you want to clear failure?"
          buttonText="Clear Failure"
          onClickConfirm={() => {
            APIIntercom.clearFailIntercomContactLogRequest({
              id: customer.xid,
              accounts_id: customer.id,
            });
            window.open(`https://api.earn2trade.com/mgmt/clear_fail/${customer.xid}`);
          }}
        />

        <DialogConfirm
          isShowMainButton
          dialogTitle="Create Finamark"
          contentText="Are you sure you want to create finamark ?"
          buttonText="Create Finamark"
          onClickConfirm={() => setPopup("fina-create")}
        />

        <DialogConfirm
          isShowMainButton
          dialogTitle="Extend Finamark"
          contentText="Are you sure you want to extend finamark ?"
          buttonText="Extend Finamark"
          onClickConfirm={() => setPopup("fina-extend")}
        />
        {allowed_features.create_discount_code_for_customer && <CreateDiscount />}

        {allowed_features.delete_customer_account && !!customer.status && (
          <DeleteCustomerAccount cus_id={customer.stripe_customer} />
        )}
      </Box>

      <Box display="flex" flexDirection="row" justifyContent="space-between" padding="10px 0">
        <CompleteEvaluation />
      </Box>
    </div>
  );
};

export default ManagementConfirmWindows;
